import React from "react";
import { ActivityQRRegisterContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { userService } from "apiServices";
import { toast } from "react-toastify";
import { setReduxWallet } from "store/reducers/walletReducer";
import { withTranslation } from "react-i18next";
import { IMG_PATH } from "utils/constants/imgPath";
import { Buttons, Displays, Headers, Icons } from "components";
import ImageSmooth from "components/Displays/ImageSmooth";

class ActivityQRRegisterContainer extends React.Component {
  _isFetching = false;
  _isRegistering = false;

  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    if (this._isFetching) return;
    this._isFetching = true;

    const { authenRedux, router } = this.props;
    const activityId = router.params?.id;

    let resArr = await Promise.all([
      userService.GET_ACTIVITY_DETAIL(activityId),
      userService.GET_ACTIVITY_HISTORY_BY_ME_ACTIVITY(
        activityId,
        authenRedux.member_type_active,
      ),
    ]);

    if (resArr && resArr[0].status === 200) {
      const data = resArr[0]?.data;
      const activityRegisData = resArr[1]?.data ? resArr[1].data : false;

      if (activityRegisData) {
        // ลงทะเบียนแล้ว
        this.setState({
          data,
          isLoading: false,
          isAlreadyRegistered: true,
        });
      } else {
        // ยังไม่ได้ลง → ลงทะเบียนอัตโนมัติ
        this.setState({ data }, () => {
          this.handleAutoRegister(data);
        });
      }
    } else {
      this.setState({ isLoading: false });
      toast.error("ไม่พบกิจกรรม");
    }
  };

  handleAutoRegister = async (data) => {
    if (this._isRegistering) return;
    this._isRegistering = true;

    const { authenRedux, router } = this.props;
    const activityId = router.params?.id;

    // ป้องกัน register ซ้ำข้าม page refresh
    const lockKey = `qr_register_lock_${activityId}`;
    if (sessionStorage.getItem(lockKey)) {
      this.setState({ isLoading: false, isAlreadyRegistered: true });
      return;
    }
    sessionStorage.setItem(lockKey, "1");

    const bodyFormData = new FormData();
    bodyFormData.append("activity_id", activityId);
    bodyFormData.append("member_type", authenRedux.member_type_active);

    let res;
    switch (data.permission_type) {
      case "1":
        res = await userService.POST_ACTIVITY_HISTORY_REGISTER(bodyFormData);
        break;
      case "2":
        res =
          await userService.POST_ACTIVITY_HISTORY_LIMIT_REGISTER(bodyFormData);
        break;
      default:
        res = await userService.POST_ACTIVITY_HISTORY_REGISTER(bodyFormData);
        break;
    }

    if (res && res.status === 200) {
      this.updateMyWallet();
      this.setState({
        isLoading: false,
        isRegistered: true,
      });
    } else {
      sessionStorage.removeItem(lockKey);
      this._isRegistering = false;
      this.setState({ isLoading: false });
      toast.error(res?.data?.error?.message || "ลงทะเบียนไม่สำเร็จ");
    }
  };

  updateMyWallet = async () => {
    let res = await userService.GET_MY_WALLET();
    if (res) {
      this.props.setReduxWallet(res.data);
    }
  };

  handleGoHome = () => {
    this.props.router.navigate(ROUTE_PATH.HOME);
  };

  handleGoBack = () => {
    this.props.router.navigate(ROUTE_PATH.HOME);
  };

  render() {
    const { t } = this.props;
    const { isLoading, data, isAlreadyRegistered, isRegistered } = this.state;

    return (
      <ActivityQRRegisterContainerStyled>
        <div className="qr_register_container">
          <Headers.NewPageHeader title={"ACTIVITY"} sub_title={"กิจกรรม"} />
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              {data && (
                <div className="activity_img_wrap">
                  <ImageSmooth
                    alt="activity"
                    src={
                      data.img
                        ? IMG_PATH + data.img
                        : "/assets/images/mockups/activities-1.jpg"
                    }
                    aspectRatio="16 / 9"
                  />
                </div>
              )}

              {isAlreadyRegistered && (
                <>
                  <div className="result_section">
                    <div className="result_icon">
                      <Icons.UnSuccessIcon width={60} height={60} />
                    </div>
                    <div className="result_title">
                      {t("You have already participated in the activity.", {
                        ns: "common",
                      })}
                    </div>
                    {data && (
                      <div className="result_activity_name">{data.name}</div>
                    )}
                  </div>
                  <div className="btn_wrap">
                    <Buttons.BgStandard
                      label={t("Back", { ns: "common" })}
                      onClick={this.handleGoBack}
                    />
                  </div>
                </>
              )}

              {isRegistered && (
                <>
                  <div className="result_section">
                    <div className="result_icon">
                      <Icons.Success width={80} height={80} />
                    </div>
                    <div className="result_title">
                      {t("You have successfully registered.", {
                        ns: "common",
                      })}
                    </div>
                    <div className="result_sub_title">
                      {t("Thank you for participating in the activity.", {
                        ns: "common",
                      })}
                    </div>
                    {data && (
                      <div className="result_activity_name">{data.name}</div>
                    )}
                  </div>
                  <div className="btn_wrap">
                    <Buttons.BgStandard
                      label={t("Home", { ns: "common" })}
                      onClick={this.handleGoHome}
                    />
                  </div>
                </>
              )}

              {!isAlreadyRegistered && !isRegistered && (
                <>
                  <div className="result_section">
                    <div className="result_icon">
                      <Icons.UnSuccessIcon width={60} height={60} />
                    </div>
                    <div className="result_title">ลงทะเบียนไม่สำเร็จ</div>
                    <div className="result_sub_title">กรุณาลองใหม่อีกครั้ง</div>
                  </div>
                  <div className="btn_wrap">
                    <Buttons.BgStandard
                      label={t("Back", { ns: "common" })}
                      onClick={this.handleGoBack}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </ActivityQRRegisterContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxWallet: (data) => dispatch(setReduxWallet(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common"])(withRouter(ActivityQRRegisterContainer)));
